import { FormControl, MenuItem, Select, type SelectChangeEvent } from "@mui/material"
import { useFormContext } from "react-hook-form"

import { FormField } from "@/components/Forms"
import { SELECT_STYLING_PROPS } from "@/constants/forms"
import { CompanyDefaultUnitOfMeasurement, CompanyPreferredMeasurementSystemEnum } from "@/graphql/codegen/graphql"
import {
  defaultUomMapping,
  preferredMeasurementSystemMapping,
} from "@/screens/Companies/constants/preferredMeasurementDataMap"

const MetricUomsOptions = [
  CompanyDefaultUnitOfMeasurement.MetricWeightKilogram,
  CompanyDefaultUnitOfMeasurement.MetricWeightTon,
]
const USStandardUomsOptions = [
  CompanyDefaultUnitOfMeasurement.UsstdWeightPound,
  CompanyDefaultUnitOfMeasurement.UsstdWeightShortTon,
]

const PreferredMeasuringSystemSelects = (): JSX.Element => {
  const { watch, setValue } = useFormContext()

  const preferredMeasurementSystem = watch("preferredMeasurementSystem")

  const handlePreferredMeasurementSystemChange = (e: SelectChangeEvent<unknown>, field: any) => {
    field.onChange(e)
    setValue("defaultUom", "")
  }

  return (
    <>
      <FormField
        name='preferredMeasurementSystem'
        label='Company Preferred System of Measurement'
        required
        render={({ field, fieldState: { error } }) => (
          <FormControl>
            <Select
              {...field}
              {...SELECT_STYLING_PROPS}
              error={Boolean(error)}
              onChange={(e) => handlePreferredMeasurementSystemChange(e, field)}
            >
              <MenuItem value={CompanyPreferredMeasurementSystemEnum.UsStandard}>
                {preferredMeasurementSystemMapping[CompanyPreferredMeasurementSystemEnum.UsStandard]}
              </MenuItem>
              <MenuItem value={CompanyPreferredMeasurementSystemEnum.Metric}>
                {preferredMeasurementSystemMapping[CompanyPreferredMeasurementSystemEnum.Metric]}
              </MenuItem>
            </Select>
          </FormControl>
        )}
      />
      <FormField
        name='defaultUom'
        label='Company Default Unit of Measurement'
        render={({ field }) => (
          <FormControl>
            <Select
              {...field}
              {...SELECT_STYLING_PROPS}
              renderValue={(value?: CompanyDefaultUnitOfMeasurement) => {
                if (!value) {
                  return <span className='text-gray-400'>Select One</span>
                }
                return defaultUomMapping[value]
              }}
            >
              <MenuItem key={field.name + "SelectOne"} className='text-gray-500' value=''>
                Select One
              </MenuItem>

              {(preferredMeasurementSystem === CompanyPreferredMeasurementSystemEnum.Metric
                ? MetricUomsOptions
                : USStandardUomsOptions
              ).map((uom) => (
                <MenuItem key={uom} value={uom}>
                  {defaultUomMapping[uom]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    </>
  )
}

export default PreferredMeasuringSystemSelects
